// AreaOpsApplyAllButton — the "Uygula" button under the photo, shown once an
// op is staged with "Listeye Ekle" — the only way an op runs (the draft popup
// has no "Uygula"). Batchable ops go out as ONE area-ops-batch request, the
// rest on their own (useAreaOpsQueue.applyStaged). Just "Uygula": no op count,
// no credit figure (the estimate still gates the insufficient-balance popup).
// There is no list: a staged op is edited by clicking its box on the image.
//
// Presentational only — AreaOpsModal owns the pins (useAreaOpsQueue) and the
// credit estimate.

import i18n from "i18next";
// Same primary button as ImageAnimatorModal's "Başlat".
import "../../common/modal/_appModal.scss";

export default function AreaOpsApplyAllButton({ credit, busy, onApplyAll, onInsufficient }) {
  const insufficient = credit?.hasSufficientBalance === false;

  const onClick = () => {
    if (insufficient) onInsufficient?.(credit);
    else onApplyAll?.();
  };

  return (
    <button
      type="button"
      className="app-modal__btn app-modal__btn--primary aops-apply-all"
      disabled={busy}
      title={insufficient ? i18n.t("AreaOps.InsufficientBalance") : undefined}
      onClick={onClick}
    >
      {i18n.t("AreaOps.Apply")}
    </button>
  );
}
